export type TProjectConfiguration = {
  canBeCreatedByHAUsers: boolean;
  canDoDocumentBulkActions: boolean;
  canSubmitDocument: boolean;
  canSponsorShareDocument: boolean;
  hasInterestedPHAs: boolean;
  hasReferenceHAOrganization: boolean;
  hasParticipatingHAOrganizations: boolean;
  shouldUseDocumentSubtype: boolean;
  canCreateStructuredDocument: boolean;
};

export const projectConfiguration: TProjectConfiguration = {
  canBeCreatedByHAUsers: false,
  canDoDocumentBulkActions: true,
  canSubmitDocument: true,
  canSponsorShareDocument: true,
  hasInterestedPHAs: false,
  hasReferenceHAOrganization: false,
  hasParticipatingHAOrganizations: false,
  shouldUseDocumentSubtype: true,
  canCreateStructuredDocument: true,
};
